<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="750px">
      <v-skeleton-loader v-if="loading" type="article, actions"></v-skeleton-loader>
      <v-card v-if="!loading">
        <v-card-title>
          <v-panel>
            <span style="font-size: 20px;">{{ $t('wkt.admin.calendar.copy-rules-window.title') }}</span>
          </v-panel>
        </v-card-title>
        <v-card-text>
          <v-container @wheel="onWheel">
            <v-form ref="form">
              <v-row no-gutters class="mt-8 d-flex align-center">
                <v-col cols="8" class="mb-14 p-0">
                  <v-autocomplete
                    attach
                    v-model="srcCalendarId"
                    :items="srcCalendars"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '100px', offsetY: true }"
                    :label="$t('wkt.admin.calendar.copy-rules-window.source_calendar')"
                    :rules="[validationRules.required]"
                    class="mr-2"
                    @change="updateDstCalendars()"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="d-flex align-center">
                <v-col cols="8" class="mb-14 p-0">
                  <v-autocomplete
                    attach
                    v-model="dstCalendarId"
                    :items="dstCalendars"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '100px', offsetY: true }"
                    :label="$t('wkt.admin.calendar.copy-rules-window.destination_calendar')"
                    :rules="[validationRules.required]"
                    class="mr-2"
                    @change="updateSrcCalendars()"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!srcCalendarId || !dstCalendarId"
            color="#185EA9"
            text
            @click="onOk()"
            style="font-size: 0.9em; font-weight: 400;"
          >{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
          <v-btn
            text
            @click="showDialog=false"
            style="font-size: 0.9em; font-weight: 400;"
          >{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog ref="dlgOpenCalendarRulesAssisstantConfirm"
      :title="$t('wkt.admin.calendar.assistant-dialog.title')"
      :message="openCalendarRulesAssisstantMessage"
      :titleOk="$t('wkt.admin.common.dialog-buttons.yes')"
      :titleCancel="$t('wkt.admin.common.dialog-buttons.no')"                
      v-on:confirmed="openCalendarRulesAssisstant($event)"
    />
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import ConfirmDialog from '../../common/ConfirmDialog';
import api from "../../../api/worktime";
import gwt from '../../../api/gwt';

export default {
  name: "CopyCalendarExerciseDialog",
  mixins: [BaseModule],
  components: {
    ConfirmDialog
  },
  data() {
    return {
      showDialog: false,
      loading: true,
      srcCalendarId: null,
      dstCalendarId: null,
      srcCalendars: [],
      dstCalendars: [],
      initialCalendars: [], 
      openCalendarRulesAssisstantMessage: '',     
    };
  },
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    // eslint-disable-next-line no-unused-vars
    open: function (action, payload) {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }

      this.srcCalendarId = null;
      this.dstCalendarId = null;
      this.openCalendarRulesAssisstantMessage = '';

      if (!payload) {
        this.srcCalendars = [];
        this.dstCalendars = [];
        this.initialCalendars = [];        
      }

      this.showDialog = true;

      this.loading = true;

      api.getFullCalendars(
        (res) => {
          this.initialCalendars = res;
          this.srcCalendars = [...this.initialCalendars.filter(c => c.numRules > 0)];
          this.dstCalendars = [...this.initialCalendars];
          this.loading = false;
        },
        (error) => {
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
          this.loading = false;
        }
      );
    },
    updateSrcCalendars() {
      this.srcCalendars = [...this.initialCalendars];

      if (this.dstCalendarId) {
        this.srcCalendars = this.srcCalendars.filter(
          (x) => x.id !== this.dstCalendarId
        );
      }
    },
    updateDstCalendars() {
      this.dstCalendars = [...this.initialCalendars];

      if (this.srcCalendarId) {
        this.dstCalendars = this.dstCalendars.filter(
          (x) => x.id !== this.srcCalendarId
        );
      }
    },
    onOk() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      api.copyCalendarRules(this.srcCalendarId, this.dstCalendarId,
        (res) => {
          this.loading = false;
          if (res) {
            this.showDialog = false;

            const srcCalendarId = this.initialCalendars.find(c => c.id === this.srcCalendarId);
            const numRules = srcCalendarId ? srcCalendarId.numRules : 0;

            //let messageOk = this.$t('wkt.admin.calendar.copy-rules-window.copied-rules');
            //messageOk = messageOk.replace("%d", numRules);
            //this.$emit("show-alert", { text: messageOk, color: "success", timeout: 3000 });
            
            let message = this.$t('wkt.admin.calendar.copy-rules-dialog.text');
            message = message.replace("%d", numRules);
            this.openCalendarRulesAssisstantMessage = message;

            this.$refs.dlgOpenCalendarRulesAssisstantConfirm.confirm(this.dstCalendarId);
          } else {
            const srcCalendarId = this.initialCalendars.find(c => c.id === this.srcCalendarId);
            const numRules = srcCalendarId ? srcCalendarId.numRules : 0;

            let messageErr = this.$t('wkt.admin.calendar.copy-rules-window.uncopied-rules');
            messageErr = messageErr.replace("%d", numRules);
            this.$emit("show-alert", { text: messageErr, color: "error", timeout: 3000 });
          }
        },
        (error) => {
          this.loading = false;
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
        }
      );
    },
    openCalendarRulesAssisstant(calendarId) {
      const payload = { 
        calendarId: calendarId, 
        openRules: true
      };

      gwt.fireEvent('OpenCalendarEvent', JSON.stringify(payload));
    },
  },
};
</script>